export default {
  COMMON_KEYS: ['userType', 'userStatus', 'webArea', 'webVersion', 'webLang'],
  MAX_ATTEMPTS: 3,
  PAGE_TYPES: {
    LOGIN: 'login',
    OVERVIEW: 'overview',
    PAYMENT: 'payment',
    PRODUCT_SCREEN: 'product_screen',
    PROFILE: 'profile',
    SETTINGS: 'settings'
  },
  TIME_TO_RETRY: 250,
  TRACK_TYPES: {
    LINK: 'link',
    VIEW: 'view'
  }
};